import { useEffect } from "react";
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  useEffect(() => {
    // scrollToTop();
  }, []);
  const scrollToTop = () => {
    const top = document.getElementById("top") as HTMLElement;
    top.scrollIntoView();
  };
  return (
    <div className="term-condition-page" id="top">
      <Helmet>

        <title>{'Privacy Policy'}</title>

        <meta name="description" content={'Details our full privacy policy. '} />

        <meta property="og:title" content={'Privacy Policy'} />

        <meta property="og:description" content={'Details our full privacy policy. '} />

      </Helmet>
      <div className="container">
        <h3 className="main-heading">Privacy Policy</h3>
        <p>
          Our full privacy policy is explained below, but the main points to note
          are:
        </p>
        <ul>
          <li>We will only ever ask for what we really need to know.</li>
          <li>
            We will collect and use the personal data that you share with us
            transparently, honestly and fairly.
          </li>
          <li>
            We will always respect your choices around the data that you share
            with us and the communication channels that you ask us to use.
          </li>
          <li>
            We will put appropriate security measures in place to protect the
            personal data that you share.
          </li>
          <li>We will never sell your data.</li>
        </ul>

        <h2>Who are we?</h2>
        <p>
          We are Prime Direct Distribution Limited and are committed to
          safeguarding your privacy. This Privacy Policy (“Policy”) sets out our
          data collection and processing practices and your options regarding how
          your personal information is used.
        </p>
        <p>
          We may change this Policy from time to time so please check this page
          occasionally to ensure that you’re happy with any changes. By using our
          website, you’re agreeing to be bound by this Policy.
        </p>
        <p>
          The provision of your personal data to us is voluntary. However, without
          providing us with your personal data, you may be unable to (as
          appropriate) receive new release information, invoices or things
          necessary in order to trade with us.
        </p>

        <h2>1. How we use the information:</h2>
        <p>We may use your information to:</p>
        <ul>
          <li>process orders that you have submitted;</li>
          <li>
            carry out our obligations arising from any transactions or sales
            contracts you have entered into by you and us;
          </li>
          <li>notify you of changes to our organisation;</li>
          <li>
            send you communications which you have requested and that may be of
            interest to you;
          </li>
          <li>
            send you quotes and invoices and pre-sale or new release information;
          </li>
          <li>process a job application;</li>
          <li>
            process payments through a securely encrypted server and send
            payments;
          </li>
          <li>set up a new customer or supplier account for you.</li>
        </ul>

        <h2>2. What information do we collect?</h2>
        <p>
          The type and amount of information we collect depends on why you are
          providing it.
        </p>
        <p>
          We will usually ask you for your name, email address and information
          about your organisation, including the name of the organisation.
        </p>
        <p>
          However, we may request other information where it is appropriate and
          relevant, for example, if we are processing an order that you have
          submitted. This additional information might include:
        </p>
        <ul>
          <li>Details of why you have decided to contact us, or</li>
          <li>Your physical address</li>
          <li>Your bank details or debit/credit card details;</li>
          <li>
            information about the services you use, services and products of
            interest to you or any marketing and/or communication preferences you
            give; and/or
          </li>
          <li>
            If you are a job applicant, the information you are asked to provide
            is as set out in the application and necessary for the purposes of
            considering the application.
          </li>
          <li>
            any other information shared with us in relation to the different
            purposes set out at clause 1
          </li>
        </ul>

        <h2>Do we process sensitive personal information?</h2>
        <p>
          Applicable law recognises certain categories of personal information as
          sensitive and therefore requiring more protection, including health
          information, ethnicity and political opinions. We will never ask you for
          this sensitive information.
        </p>

        <h2>3. Communications and marketing</h2>
        <p>
          Where you have provided us with your physical address, we may contact
          you by post; and where you have provided appropriate consent, also by
          telephone and e-mail, with targeted communications to let you know about
          our releases and/or activities that we consider may be of particular
          interest.
        </p>

        <h2>4. Third-party payments</h2>
        <p>
          We may pass your information to our third-party service providers,
          agents subcontractors and other associated organisations for the
          purposes of completing tasks and providing services to you on our behalf
          (for example to process payments or send you mailings/ arrange
          delivery).
        </p>
        <p>
          These third parties have access to your Personal Information only to
          perform these specific tasks on our behalf and are obligated not to
          disclose or use it for any other purpose.
        </p>

        <h2>5. Children’s data</h2>
        <p>
          We do not knowingly process data of any person under the age of 16. If
          we come to discover, or have reason to believe, that you are 15 and
          under and we are holding your personal information, we will delete that
          information within a reasonable period and withhold our services
          accordingly.
        </p>

        <h2>6. Other disclosures</h2>
        <p>
          We will disclose your Personal Information where required to do so by
          law or in accordance with an order of a court of competent jurisdiction,
          or if we believe that such action is necessary to comply with the law
          and the reasonable requests of law enforcement or to protect the
          security or integrity of our Service.
        </p>
        <p>International Transfer</p>
        <p>
          If you are located outside the United Kingdom and choose to provide
          information to us, please note that we transfer the information,
          including Personal Information, to the United Kingdom and process it
          there.
        </p>
        <p>
          Your consent to this Privacy Policy followed by your submission of such
          information represents your agreement to that transfer.
        </p>
        <p>
          In the event that a dispute arises with regards to the international
          transfer of data, you agree that the courts of England and Wales shall
          have exclusive jurisdiction over the matter.
        </p>

        <h2>7. Security of and access to your personal data</h2>
        <p>
          We endeavour to ensure that there are appropriate and proportionate
          technical and organisational measures to prevent the loss, destruction,
          misuse, alteration, unauthorised disclosure or of access to your
          personal information.
        </p>
        <p>
          Your information is only accessible by appropriately trained staff and
          contractors.
        </p>
        <p>
          The security of your Personal Information is important to us but
          remember that no method of transmission over the Internet, or method of
          electronic storage is 100% secure. While we strive to use commercially
          acceptable means to protect your Personal Information, we cannot
          guarantee its absolute security. As such we make no warranties as to the
          level of security afforded to your data, except that we will always act
          in accordance with the relevant UK and EU legislation.
        </p>
        <p>
          Otherwise than as set out in this Privacy Policy, we will only ever
          share your data with your informed consent.
        </p>

        <h2>8. Your rights and how consent works</h2>
        <p>
          You have a choice about whether or not you wish to receive information
          from us. If you do not want to receive communications from us about our
          products and services, then you can select your choices by ticking the
          relevant boxes situated on the form on which we collect your
          information.
        </p>
        <p>
          Where we rely on your consent to use your personal information, you have
          the right to withdraw that consent at any time. This includes the right
          to ask us to stop using your personal information for direct marketing
          purposes or to be unsubscribed from our email list at any time. You also
          have the following rights:
        </p>
        <ul>
          <li>
            Right to be informed – you have the right to be told how your personal
            information will be used. This Policy and other policies and
            statements used on our website and in our communications are intended
            to provide you with a clear and transparent description of how your
            personal information may be used.
          </li>
          <li>
            Right of access – you can write to us to ask for confirmation of what
            information we hold on you and to request a copy of that information.
            Provided we are satisfied that you are entitled to see the information
            requested and we have successfully confirmed your identity, we have 30
            days to comply.
          </li>
          <li>
            Right of erasure – as from 25 May 2018, you can ask us for your
            personal information to be deleted from our records. In many cases we
            would propose to suppress further communications with you, rather than
            delete it.
          </li>
          <li>
            Right of rectification – if you believe our records of your personal
            information are inaccurate, you have the right to ask for those
            records to be updated.
          </li>
          <li>
            Right to restrict processing – you have the right to ask for
            processing of your personal data to be restricted if there is
            disagreement about its accuracy or legitimate usage.
          </li>
          <li>
            Right to data portability – to the extent required by the General Data
            Protection Regulations (“GDPR”) where we are processing your personal
            information (i) under your consent, (ii) because such processing is
            necessary for the performance of a contract to which you are party or
            to take steps at your request prior to entering into a contact or
            (iii) by automated means, you may ask us to provide it to you – or
            another service provider – in a machine-readable format.
          </li>
        </ul>
        <p>
          To exercise these rights, please send a description of the personal
          information in question using the contact details in section 14 below.
        </p>
        <p>
          Where we consider that the information with which you have provided us
          does not enable us to identify the personal information in question, we
          may ask you for (i) personal identification and/or (ii) further
          information.
        </p>
        <p>
          Please note that some of these rights only apply in limited
          circumstances. For more information, we suggest that you consult ICO
          guidance –{" "}
          <a href="https://ico.org.uk/for-organisations/guide-to-the-general-data-protection-regulation-gdpr">
            https://ico.org.uk/for-organisations/guide-to-the-general-data-protection-regulation-gdpr
          </a>
        </p>
        <p>
          You are further entitled to make a complaint about us or the way we have
          processed your data to the Information Commissioner’s Office (“ICO”).
          For further information on how to exercise this right, please see the
          guidance at{" "}
          <a href="https://ico.org.uk/for-the-public/personal-information">
            https://ico.org.uk/for-the-public/personal-information
          </a>
          . The contact details of the ICO can be found here:{" "}
          <a href="https://ico.org.uk/global/contact-us">
            https://ico.org.uk/global/contact-us
          </a>
          .
        </p>

        <h2>9. Lawful processing</h2>
        <p>
          We are required to have one or more lawful grounds to process your
          personal information. Only four of these are relevant to us:
        </p>
        <ul>
          <li>
            Consent
            <ul>
              <li>
                We will ask for your consent to use your information to send you
                electronic communications such as newsletters and marketing
                emails, for targeted advertising, and if you ever share sensitive
                personal information with us.
              </li>
            </ul>
          </li>
          <li>
            Contractual relationships
            <ul>
              <li>
                Most of our interactions with subscribers and website users are
                voluntary and not contractual. However, sometimes it will be
                necessary to process personal information so that we can enter
                contractual relationships with people. For example, if you apply
                for employment with us, or if you purchase services or goods from
                us.
              </li>
            </ul>
          </li>
          <li>
            Legal obligations
            <ul>
              <li>
                Sometimes we will be obliged to process your personal information
                due to legal obligations which are binding on us. We will only
                ever do so when strictly necessary.
              </li>
            </ul>
          </li>
          <li>
            Legitimate interests
            <ul>
              <li>
                Applicable law allows personal information to be collected and
                used if it is reasonably necessary for our legitimate activities
                (as long as its use is fair, balanced and does not unduly impact
                individuals’ rights).
              </li>
              <li>
                We will rely on this ground to process your personal data when it
                is not practical or appropriate to ask for consent.
              </li>
              <li>
                When we use your personal information, we will consider if it is
                fair and balanced to do so and if it is within your reasonable
                expectations. We will balance your rights and our legitimate
                interests to ensure that we use your personal information in ways
                that are not unduly intrusive or unfair in other ways.
              </li>
            </ul>
          </li>
        </ul>

        <h2>10. Data retention</h2>
        <p>
          In general, unless still required in connection with the purpose(s) for
          which it was collected and/or is processed, we remove your personal
          information from our records five years after the date it was collected.
          However, if before that date (i) your personal information is no longer
          required in connection with such purpose(s), (ii) we are no longer
          lawfully entitled to process it or (iii) you ask us to delete it we will
          remove it from our records at the relevant time.
        </p>
        <p>
          In the event that you ask us to stop sending you direct marketing/other
          electronic communications, we will keep your name on our internal
          suppression list to ensure that you are not contacted again.
        </p>
        <p>
          We review our retention periods for personal information on a regular
          basis (see item 11 of this Privacy Statement). We are legally required
          to hold some types of information to fulfil our statutory obligations.
          You can request to remove your personal information at any time by
          emailing{" "}
          <a href="mailto:info@primedirectdist.co.uk">
            info@primedirectdist.co.uk
          </a>
        </p>

        <h2>11. Policy amendments</h2>
        <p>
          We keep this Privacy Policy under regular review and reserve the right
          to update from time-to-time by posting an updated version on our
          website, not least because of changes in applicable law. We recommend
          that you check this Privacy Policy occasionally to ensure you remain
          happy with it. We may also notify you of changes to our privacy policy
          by email.
        </p>

        <h2>12. Third party websites</h2>
        <p>
          We link our website to other sites. This Privacy Policy does not cover
          external websites and we are not responsible for the privacy practices
          or content of those sites. We encourage you to read the privacy policies
          of any external websites you visit via links on our website.
        </p>

        <h2>13. Updating information</h2>
        <p>
          You can check the personal data we hold about you, and ask us to update
          it where necessary, by emailing us at{" "}
          <a href="mailto:info@primedirectdist.co.uk">
            info@primedirectdist.co.uk
          </a>
        </p>

        <h2>14. Contact</h2>
        <p>
          We are not required by law to have a “Data Protection Officer” –
          however, we have a Data Protection Manager.
        </p>
        <p>
          Please let us know if you have any queries or concerns whatsoever about
          the way in which your data is being processed by emailing at{" "}
          <a href="mailto:info@primedirectdist.co.uk">
            info@primedirectdist.co.uk
          </a>
        </p>
        <p>or by writing to us at the following address:</p>
        <p>
          Data Protection Manager
          <br />
          Prime Direct Distribution
          <br />
          21 Queens Road
          <br />
          Brighton
          <br />
          BN1 3XA
          <br />
        </p>
      </div>
    </div>
  );
};
export default PrivacyPolicy;
